module.exports = __webpack_public_path__ + "static/media/logo.f8054d31.png";